// letterProgress.js — browser-local progress for the letter lessons.
// Mirrors stats.js's localStorage approach. No locking (soft lead): every
// lesson is openable; we only record completion and best score.

const STORAGE_KEY = 'dari-letters-v1';

function load() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || { completed: {}, scores: {} };
  } catch (_) {
    return { completed: {}, scores: {} };
  }
}

function save(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (_) {}
}

export function getProgress() {
  return load();
}

export function isLessonComplete(id) {
  return !!load().completed[id];
}

// score is a 0–100 percentage; keeps the best.
export function markLessonComplete(id, score = 100) {
  const data = load();
  data.completed[id] = true;
  data.scores[id] = Math.max(data.scores[id] || 0, Math.round(score));
  save(data);
}

export function completedCount() {
  return Object.keys(load().completed).length;
}
